import { Component, OnInit } from "@angular/core";
import { SharedModule } from "@Shared/shared.module";
import $ from 'jquery';
import { DashboardHeaderComponent, DashboardCasesComponent, TeamDashboardComponent } from "./components";
import { PerformanceAccount } from "./components/dashboard-header/dashboard-header.component";
import { AppService } from '../app.service';
import { ActivatedRoute } from "@angular/router";
import { TeamsService } from "@Services";
import { GetManageTeamsResponse } from "@App/manage-users/models/get-manage-teams-response.interface";
import { FeatureManagerService } from "@Services/global/feature-manager/feature-manager.service";
import { FeatureToggle } from "@App/enums";
import { TeamDashboardDetailsDto, TeamPerformanceData } from "@Models";

@Component({
    selector: 'app-my-dashboard',
    host: { 'class': 'content' },
    templateUrl: './my-dashboard.component.html',
    styleUrls: ['./my-dashboard.component.scss'],
    imports: [SharedModule, DashboardHeaderComponent, DashboardCasesComponent, TeamDashboardComponent]
})

export class MyDashboardComponent implements OnInit {

    userName: string;
    userId: string;
    clientId: string;
    teams: GetManageTeamsResponse[] = [];
    teamId: string = 'my-dashboard';
    isSupervisorDashboardEnabled: boolean = false;
    accounts: PerformanceAccount[] = [];
    accountFilter: string[] = [];
    isAccountFilterEnabled: boolean = false;
    rawPerformanceData: TeamPerformanceData | null = null;
    rawTeamDashboardData: any[] | null = null;
    teamTasksEnabled: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private appService: AppService,
        private teamsService: TeamsService,
        private featureManagerService: FeatureManagerService,
    ) {
    }

    ngOnInit(): void {
        this.userName = this.appService.getUsername();
        this.userId = this.appService.getUserId();
        $('#sidenav').removeClass('hidenav');
        this.activatedRoute.data.subscribe(data => {
            const uniqueClientIds = [...new Set<string>(data.accounts.map((item: any) => item.clientId))];
            if (uniqueClientIds.length == 1) {
                this.clientId = uniqueClientIds[0];
            }
        });
        this.subscribeFeatureFlags();
    }

    subscribeFeatureFlags() {
        this.featureManagerService.isEnabled(FeatureToggle.GlobalEnableSupervisorDashboard).subscribe(isEnabled => {
            this.isSupervisorDashboardEnabled = isEnabled;
            this.loadTeams();
        });
        this.featureManagerService.isEnabled(FeatureToggle.GlobalSupervisorDashboardEnableAccountFilter).subscribe(isEnabled => {
            this.isAccountFilterEnabled = isEnabled;
        });
    }

    loadTeams() {
        this.teamsService.getTeamsForUser(this.userId, true).subscribe((teams: GetManageTeamsResponse[]) => {
            this.teams = teams;
        });
    }

    loadPerformanceData(): void {
        if (!this.clientId || this.teamId === 'my-dashboard') {
            this.rawPerformanceData = null;
            this.updateAccountsFromAllSources();
            return;
        }
        this.teamsService.getTeamPerformanceData(this.clientId, this.teamId).subscribe((data: TeamPerformanceData) => {
            this.rawPerformanceData = data;
            this.updateAccountsFromAllSources();
        });
    }

    loadTeamDashboardData(): void {
        if (!this.clientId || this.teamId === 'my-dashboard') {
            this.rawTeamDashboardData = null;
            this.updateAccountsFromAllSources();
            return;
        }
        this.teamsService.getTeamDashboardData(this.clientId, this.teamId).subscribe((data: TeamDashboardDetailsDto) => {
            this.teamTasksEnabled = data?.tasksEnabled ?? false;
            this.rawTeamDashboardData = data?.members ?? [];
            this.updateAccountsFromAllSources();
        });
    }

    private updateAccountsFromAllSources(): void {
        const seen = new Set<string>();
        const accounts: PerformanceAccount[] = [];

        const addFromEntries = (entries: { parentAccountId?: string; accountName?: string; accountCode?: string }[]) => {
            for (const entry of entries) {
                if (entry.parentAccountId && entry.parentAccountId != '00000000-0000-0000-0000-000000000000' && !seen.has(entry.parentAccountId)) {
                    seen.add(entry.parentAccountId);
                    accounts.push({ parentAccountId: entry.parentAccountId, name: entry.accountName, code: entry.accountCode });
                }
            }
        };

        if (this.rawPerformanceData) {
            addFromEntries(this.rawPerformanceData.avgCaseCycleTime6Months || []);
            addFromEntries(this.rawPerformanceData.slaAdherence || []);
            addFromEntries(this.rawPerformanceData.teamMemberSlaAdherence || []);
            addFromEntries(this.rawPerformanceData.teamMemberAvgCycleTime6Months || []);
            addFromEntries(this.rawPerformanceData.queueCycleTimes || []);
            addFromEntries(this.rawPerformanceData.avgTaskCycleTime6Months || []);
        }

        for (const user of this.rawTeamDashboardData || []) {
            for (const caseItem of user.casesAssigned || []) {
                if (caseItem.parentAccountId && !seen.has(caseItem.parentAccountId)) {
                    seen.add(caseItem.parentAccountId);
                    accounts.push({ parentAccountId: caseItem.parentAccountId, name: caseItem.accountName, code: caseItem.accountCode });
                }
            }
        }

        accounts.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        this.accounts = accounts;
    }

    getTeamById(teamId: string) {
        return this.teams.find(team => team.id === teamId);
    }

    handleTeamValueEmitted(value: string) {
        this.teamId = value;
        this.accountFilter = [];
        this.rawPerformanceData = null;
        this.rawTeamDashboardData = null;
        this.teamTasksEnabled = false;
        this.accounts = [];
        this.loadPerformanceData();
        this.loadTeamDashboardData();
    }

    handleAccountValueEmitted(value: string[]) {
        this.accountFilter = value;
    }
}